import { fetchChannelsInMarketResearch } from '@/api/business/marketResearch'
import { useQuery } from '@tanstack/react-query'

export const ChannelInMarketResearchKeys = {
    all: ['channelinmarketresearch'] as const,
    lists: () => [...ChannelInMarketResearchKeys.all, 'list'] as const,
    list: (page: number, perPage: number, filters: any) =>
        [...ChannelInMarketResearchKeys.lists(), page, perPage, filters] as const,
    details: () => [...ChannelInMarketResearchKeys.all, 'detail'] as const,
    detail: (params: number) => [...ChannelInMarketResearchKeys.details(), params] as const,
}

export const useChannelInMarketResearchQuery = (SK_PESQUISA: number) => {
    return useQuery({
        queryFn: () => fetchChannelsInMarketResearch(SK_PESQUISA),
        queryKey: ChannelInMarketResearchKeys.detail(SK_PESQUISA),
        enabled: Boolean(SK_PESQUISA),
    })
}
